import { browserPushStatus } from "./browser-push";
export { notificationPermissionHint, watchBrowserPush } from "./browser-push";
import { supabase, sessionUser } from "./supabase";
import { capabilities, isNative, platform } from "./platform";
import { links } from "./links";
export async function savePushToken(token: string) {
  const user = await sessionUser();
  if (!user) return;
  const { error } = await supabase.rpc("register_device_push_token", {
    p_token: token,
    p_platform: platform(),
  });
  if (error) throw error;
}
export async function notificationPermission() {
  if (!isNative()) return browserPushStatus();
  if (!capabilities().push) return "unavailable";
  const { FirebaseMessaging } = await import("@capacitor-firebase/messaging");
  return (await FirebaseMessaging.checkPermissions()).receive;
}
/** A notification payload's UUID field, or undefined when absent or malformed. */
export function payloadId(data: Record<string, unknown>, key: string) {
  const value = data[key];
  return typeof value === "string" && /^[0-9a-f-]{36}$/i.test(value) ? value : undefined;
}
/** The most specific screen a push notification can open: a comment rather than its
 * post, a reply rather than its thread. */
export function notificationRoute(data: Record<string, unknown>) {
  const post = payloadId(data, "post_id");
  if (post) return links.post(post, { comment: payloadId(data, "reply_id") });
  const topic = payloadId(data, "topic_id");
  if (topic)
    return links.discuss({ topic, thread: payloadId(data, "thread_id"), reply: payloadId(data, "reply_id") });
  if (String(data.type ?? "").includes("application")) return links.onboarding();
  const person = payloadId(data, "target_user_id");
  if (person) return links.person(person);
  return links.home();
}
